import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const Copyright = Loadable({
    loader: () => import(/* webpackChunkName: "Copyright" */ './copyright'),
    loading: () => <div />,
});
export const HomeFooter = Loadable({
    loader: () => import(/* webpackChunkName: "HomeFooter" */ './homeFooter'),
    loading: () => <div />,
});
